module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/reservation-dfd0de731788c3d8a2be235183b7f912.webp";